import { type Group, type SetComplexImmerStateAction } from '@/lib/types';
import { createContext } from 'react';

const GroupsContext = createContext<
  | [true, null, () => void]
  | [false, Group[], SetComplexImmerStateAction<Group[]>]
>([true, null, () => {}]);

export default GroupsContext;
